export default __webpack_public_path__ + "static/media/buzz.1b5570a1.webp";